// extracted by mini-css-extract-plugin
export var diamondIcon = "ExoticSelection-module--diamondIcon--016ac";
export var exoticOutcomes = "ExoticSelection-module--exoticOutcomes--3251b";
export var outcomeName = "ExoticSelection-module--outcomeName--f6117";